import { useEffect, useState } from "react";
import {
  // fetchSpotifyPlaylists,
  SpotifyPlaylist,
} from "../../../hooks/useSpotify";
import localSpotifyData from "./spotifyHard.json";
import "./Spotify.css";


// the tokens of spotify works HORRENDOUSLY bad, so for now im just using local data. anyways i dont update my playlists that often
export function Spotify() {
  const [playlists, setPlaylists] = useState<SpotifyPlaylist[]>([]);

  useEffect(() => {
    setPlaylists(localSpotifyData.playlists || []);
    /*
    fetchSpotifyPlaylists()
      .then(() => setPlaylists(localSpotifyData.playlists || []))
      //      .then((data) => setPlaylists(data.playlists || []))
      .catch(() => setPlaylists(localSpotifyData.playlists || []));
      */
  }, []);

  return (
    <>
      <h4>My playlists ! &gt;&lt; </h4>
      <div className="playlists-grid">
        {playlists.map((playlist) => (
          <div key={playlist.id} className="playlist-item">
            {playlist.images[0] && (
              <a
                href={playlist.external_urls.spotify}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={playlist.images[0].url}
                  alt={playlist.name}
                  style={{ width: 120, height: 120, objectFit: "cover" }}
                />
              </a>
            )}
              <div className="playlist-info">
                  <h4>{playlist.name}</h4>
                <p>{playlist.description}</p>
                <span>{playlist.tracks.total} songs</span>
              </div>
            
          </div>
        ))}
      </div>
    </>
  );
}

export default Spotify;